import Vue from 'vue';
export default new Vue();



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/stock-check/stock-check-event.jsx